jQuery(document).ready(function($){
	var attrs_value = [];
	var ajaxRequest = false;
	
	function fetch_product(){
		var value = $(this).find('input').val();
		var attribute = $(this).data('attribute');
		var attrValue = $(this).data('value');
		attrs_value[attribute] = Array.isArray(attrs_value[attribute]) ? attrs_value[attribute] : [];
		if (attribute === 'orderby' || attribute === 'min_price' || attribute === 'max_price') {
			attrs_value[attribute] = value;
		} else if (attrs_value[attribute].length > 0) {
			var index_attr = attrs_value[attribute].indexOf(value);
			(index_attr === -1) ? attrs_value[attribute].push(value):attrs_value[attribute].splice(index_attr, 1);
		} else {
			attrs_value[attribute].push(value);
		}
		ajax_fetch(attrs_value);
	}
	function ajax_fetch(attrs_value){
		if (ajaxRequest) {
			ajaxRequest.abort();
			ajaxRequest = false;
		}
		ajaxRequest = $.ajax({
			url: productFilter.ajaxurl,
			type:'POST',
			data:{
				action:'products_in_filter',
				attributes: Object.assign({}, attrs_value) 
			},
			beforeSend:function(data){
				$('.products').html('<img class="preloader" src="/wp-content/plugins/product-filters/assets/img/loader.png">');
				$('.pagination-section').hide();
			},
			success:function(res){
				$('.products').html(res); 
				$('.pagination-section').hide();
			}
		});
		return true;
	}
	$('.select_option').on('change', fetch_product);
	$('#active_values').on('click', 'span', function(){
		Object.keys(attrs_value).forEach((key) => {
			if(Array.isArray(attrs_value[key])) {
				const index = attrs_value[key].indexOf($(this).closest('p').data('name'));
				if(index !== -1) {
					attrs_value[key].splice(index, 1);
				}
			} else if(key === 'orderby') {
				attrs_value[key] = [];
			} 
			
		});
		ajax_fetch(attrs_value);
		if ($('#active_values').children().length > 1) {
			$("#reset_filter").show();
		} else {
			$("#reset_filter").hide();
		}
		$('*[data-value="'+ $(this).closest('p').data('name') +'"]').removeClass('active');
		$('*[data-value="'+ $(this).closest('p').data('name') +'"]').find('input').prop('checked',false);
		$(this).closest('p').remove();
	});
})